module.exports = {
    productSettings: {

        immunsystem_aloevera_trinkgel_honey: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'immunsystem',
            productImage: 'data/zeile-1_1_Ein_kraftvolles_Immunssystem/Produkte/Immunssystem_AloeVera_Tinkgel_Honey_seite02.jpg',
            // infoVideo: 'data/zeile-1_1_Ein_kraftvolles_Immunssystem/Info/LR-IMMUNSYSTEM_seite02/1_LR_DAILY_ESSENTIALS.mp4',
            // videoPage: 'immunsystem_aloevera_trinkgel_honey'
        },

        immunsystem_cistus_kapseln: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'immunsystem',
            productImage: 'data/zeile-1_1_Ein_kraftvolles_Immunssystem/Produkte/LR-anwendungsgebiete_IMMUNSYSTEM-seite03.jpg'
        },

        immunsystem_cistus_incanus_tee: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'immunsystem',
            productImage: 'data/zeile-1_1_Ein_kraftvolles_Immunssystem/Produkte/LR-anwendungsgebiete_IMMUNSYSTEM_cistusincanus-tee.jpg'
        },

        immunsystem_cistus_mundspray: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'immunsystem',
            productImage: 'data/zeile-1_1_Ein_kraftvolles_Immunssystem/Produkte/LR-anwendungsgebiete_IMMUNSYSTEM-seite04.jpg'
        },

        immunsystem_colostrum_kapseln: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'immunsystem',
            productImage: 'data/zeile-1_1_Ein_kraftvolles_Immunssystem/Produkte/LR-anwendungsgebiete_IMMUNSYSTEM-seite05.jpg'
        },

        immunsystem_colostrum_liquid: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'immunsystem',
            productImage: 'data/zeile-1_1_Ein_kraftvolles_Immunssystem/Produkte/LR-anwendungsgebiete_IMMUNSYSTEM-seite06.jpg'
        },

        immunsystem_vita_aktiv_rote_fruechte: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'immunsystem',
            productImage: 'data/zeile-1_1_Ein_kraftvolles_Immunssystem/Produkte/LR-anwendungsgebiete_IMMUNSYSTEM-seite07.jpg'
        },

        immunsystem_pro12: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'immunsystem',
            productImage: 'data/zeile-1_1_Ein_kraftvolles_Immunssystem/Produkte/LR-anwendungsgebiete_IMMUNSYSTEM-seite08.jpg'
        },




        beweglichkeit_aloevera_trinkgel_freedom: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'beweglichkeit',
            productImage: 'data/zeile-1_2_Beweglichkeit/Produkte/LR-anwendungsgebiete_BEWEGLICHKEIT2.jpg',
        },
        beweglichkeit_freedom_kapseln: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'beweglichkeit',
            productImage: 'data/zeile-1_2_Beweglichkeit/Produkte/LR-anwendungsgebiete_BEWEGLICHKEIT3.jpg',
        },
        beweglichkeit_pro_balance: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'beweglichkeit',
            productImage: 'data/zeile-1_2_Beweglichkeit/Produkte/LR-anwendungsgebiete_BEWEGLICHKEIT4.jpg',
            videoPage: 'beweglichkeit_pro_balance_videos'
        },
        beweglichkeit_colostrum_kapseln: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'beweglichkeit',
            productImage: 'data/zeile-1_2_Beweglichkeit/Produkte/LR-anwendungsgebiete_BEWEGLICHKEIT5.jpg',
        },
        beweglichkeit_colostrum_liquid: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'beweglichkeit',
            productImage: 'data/zeile-1_2_Beweglichkeit/Produkte/LR-anwendungsgebiete_BEWEGLICHKEIT6.jpg',
        },
        beweglichkeit_msm_bodygel: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'beweglichkeit',
            productImage: 'data/zeile-1_2_Beweglichkeit/Produkte/LR-anwendungsgebiete_BEWEGLICHKEIT7.jpg',
        },
        beweglichkeit_thermo_lotion: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'beweglichkeit',
            productImage: 'data/zeile-1_2_Beweglichkeit/Produkte/LR-anwendungsgebiete_BEWEGLICHKEIT8.jpg',
        },


        kreislauf_aloevera_trinkgel_sivera: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'kreislauf',
            productImage: 'data/zeile-1_3_Herz_und_Kreislauf/Produkte/LR-anwendungsgebiete_STAERKUNGHERZKREISLAUF2.jpg',
        },
        kreislauf_omega3: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'kreislauf',
            productImage: 'data/zeile-1_3_Herz_und_Kreislauf/Produkte/LR-anwendungsgebiete_STAERKUNGHERZKREISLAUF3.jpg',
        },
        kreislauf_pro_balance: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'kreislauf',
            productImage: 'data/zeile-1_3_Herz_und_Kreislauf/Produkte/LR-anwendungsgebiete_STAERKUNGHERZKREISLAUF4.jpg',
            videoPage: 'kreislauf_pro_balance_videos'
        },
        kreislauf_vita_aktiv: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'kreislauf',
            productImage: 'data/zeile-1_3_Herz_und_Kreislauf/Produkte/LR-anwendungsgebiete_STAERKUNGHERZKREISLAUF5.jpg',
        },
        kreislauf_cistus_tee: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'kreislauf',
            productImage: 'data/zeile-1_3_Herz_und_Kreislauf/Produkte/LR-anwendungsgebiete_STAERKUNGHERZKREISLAUF6.jpg',
        },
        kreislauf_reishi: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'kreislauf',
            productImage: 'data/zeile-1_3_Herz_und_Kreislauf/Produkte/LR-anwendungsgebiete_STAERKUNGHERZKREISLAUF7.jpg',
        },


        erschoepfung_vita_aktiv: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'erschoepfung',
            productImage: 'data/zeile-1_4_Erschoepfung/Produkte/LR-anwendungsgebiete_ERSCHOEPFUNG6.jpg',
        },
        erschoepfung_pro_balance: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'erschoepfung',
            productImage: 'data/zeile-1_4_Erschoepfung/Produkte/LR-anwendungsgebiete_ERSCHOEPFUNG7.jpg',
            videoPage: 'erschoepfung_pro_balance_videos'
        },
        erschoepfung_mind_master_extreme: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'erschoepfung',
            productImage: 'data/zeile-1_4_Erschoepfung/Produkte/LR-anwendungsgebiete_ERSCHOEPFUNG8.jpg',
        },
        erschoepfung_mind_master_red: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'erschoepfung',
            productImage: 'data/zeile-1_4_Erschoepfung/Produkte/LR-anwendungsgebiete_ERSCHOEPFUNG9.jpg',
        },
        erschoepfung_mind_master_green: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'erschoepfung',
            productImage: 'data/zeile-1_4_Erschoepfung/Produkte/LR-anwendungsgebiete_ERSCHOEPFUNG10.jpg',
        },
        erschoepfung_reishi: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'erschoepfung',
            productImage: 'data/zeile-1_4_Erschoepfung/Produkte/LR-anwendungsgebiete_ERSCHOEPFUNG11.jpg',
        },


        stress_mind_master_extreme: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'stress',
            productImage: 'data/zeile-1_5_Stress/Produkte/LR-anwendungsgebiete_STRESS4.jpg',
        },
        stress_pro12: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'stress',
            productImage: 'data/zeile-1_5_Stress/Produkte/LR-anwendungsgebiete_STRESS5.jpg',
        },
        stress_pro_balance: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'stress',
            productImage: 'data/zeile-1_5_Stress/Produkte/LR-anwendungsgebiete_STRESS6.jpg',
        },
        stress_colostrum_kapseln: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'stress',
            productImage: 'data/zeile-1_5_Stress/Produkte/LR-anwendungsgebiete_STRESS7.jpg',
        },
        stress_colostrum_liquid: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'stress',
            productImage: 'data/zeile-1_5_Stress/Produkte/LR-anwendungsgebiete_STRESS8.jpg',
        },
        stress_reishi: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'stress',
            productImage: 'data/zeile-1_5_Stress/Produkte/LR-anwendungsgebiete_STRESS9.jpg',
        },


        allergien_cistus_incanus_tee: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'allergien',
            productImage: 'data/zeile-2_1_Allergien/Produkte/LR-anwendungsgebiete_ALLERGIEN4.jpg',
        },
        allergien_cistus_incanus_kapsel: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'allergien',
            productImage: 'data/zeile-2_1_Allergien/Produkte/LR-anwendungsgebiete_ALLERGIEN5.jpg',
        },
        allergien_microsilver_face: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'allergien',
            productImage: 'data/zeile-2_1_Allergien/Produkte/LR-anwendungsgebiete_ALLERGIEN6.jpg',
        },
        allergien_pro12: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'allergien',
            productImage: 'data/zeile-2_1_Allergien/Produkte/LR-anwendungsgebiete_ALLERGIEN12.jpg',
        },
        allergien_hautpflege_allgemein: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'allergien',
            productImage: 'data/zeile-2_1_Allergien/Produkte/LR-anwendungsgebiete_ALLERGIEN13.jpg',
        },


        verletzungen_specialcare_box: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'verletzungen',
            productImage: 'data/zeile-2_2_Verletzungen/Produkte/LR-anwendungsgebiete_VERLETZUNGEN2.jpg',
        },
        verletzungen_notfallspray: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'verletzungen',
            productImage: 'data/zeile-2_2_Verletzungen/Produkte/LR-anwendungsgebiete_VERLETZUNGEN3.jpg',
        },
        verletzungen_concentrat: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'verletzungen',
            productImage: 'data/zeile-2_2_Verletzungen/Produkte/LR-anwendungsgebiete_VERLETZUNGEN4.jpg',
        },
        verletzungen_propolis_creme: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'verletzungen',
            productImage: 'data/zeile-2_2_Verletzungen/Produkte/LR-anwendungsgebiete_VERLETZUNGEN5.jpg',
        },


        zahnmund_zahngel_ohne_fluorid: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'zahnmund',
            productImage: 'data/zeile-2_3_ZahnMund/Produkte/LR-anwendungsgebiete_ZAHNMUND2.jpg',
        },
        zahnmund_zahngel_mit_fluorid: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'zahnmund',
            productImage: 'data/zeile-2_3_ZahnMund/Produkte/LR-anwendungsgebiete_ZAHNMUND3.jpg',
        },
        zahnmund_microsilver_zahncreme: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'zahnmund',
            productImage: 'data/zeile-2_3_ZahnMund/Produkte/LR-anwendungsgebiete_ZAHNMUND4.jpg',
        },
        zahnmund_microsilver_mundspuelung: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'zahnmund',
            productImage: 'data/zeile-2_3_ZahnMund/Produkte/LR-anwendungsgebiete_ZAHNMUND_mundspuelung.jpg',
        },
        zahnmund_microsilver_mundspray: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'zahnmund',
            productImage: 'data/zeile-2_3_ZahnMund/Produkte/LR-anwendungsgebiete_ZAHNMUND_mundspray.jpg',
        },
        zahnmund_cistus_incanus_spray: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'zahnmund',
            productImage: 'data/zeile-2_3_ZahnMund/Produkte/LR-anwendungsgebiete_ZAHNMUND5.jpg',
        },
        zahnmund_microsilver_kaugummi: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'zahnmund',
            productImage: 'data/zeile-2_3_ZahnMund/Produkte/LR-anwendungsgebiete_ZAHNMUND6.jpg',
        },
    }
}